import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBettingCenterConfig() {
    return {
        custom: {
            [PALETTE_IDS.BETSLIP]: {
                PlaceBetContent: {
                    placeBetButton: {
                        animation: {
                            animationDuration: 0, // according to DBX-11438
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.BET_RECEIPT]: {
                BET_RECEIPT_DOWNLOAD_PDF_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND7,
                BET_RECEIPT_BET_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
            },
            [PALETTE_IDS.BETTING_CENTER]: {
                BETTING_CENTER_TAB_BUTTON_BG: COLOR.BRAND.BACKGROUND6,
                BETTING_CENTER_TAB_BUTTON_TEXT: COLOR.BRAND.FOREGROUND1,

                BETTING_CENTER_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
            },
            [PALETTE_IDS.BETSLIP]: {
                BETSLIP_REMOVE_ALL_BUTTON: {
                    TERTIARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },

                BETSLIP_BB_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND3,

                // Freebets
                BETSLIP_FREE_BETS_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },

                // Sliding betslip
                SLIDING_BETSLIP_BUTTON_FREEBETS_CONTAINER_BG: COLOR.BRAND.FOREGROUND6,
                SLIDING_BETSLIP_BUTTON_FREEBETS_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.NUMERIC_KEYPAD]: {
                KEYPAD_COMPACT_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                KEYPAD_INCREASE_BUTTON_BG: COLOR.BRAND.ACCENT3,
                KEYPAD_BUTTON: {
                    TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT1,
                },
            },
            [PALETTE_IDS.YOUR_BETS]: {
                OPEN_BET_LIVE_EVENT_TIMING_STATUS: {
                    EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.FOREGROUND1,
                },
                OPEN_BET_RESULT_TEXT: COLOR.BRAND.ACCENT2,
            },
            [PALETTE_IDS.OVERASK]: {
                OVERASK_REVIEWING_TEXT: COLOR.BRAND.FOREGROUND2,
                OVERASK_TIMER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                OVERASK_BET_OFFER_STATUS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_LARGE,
                },
                OVERASK_BET_OFFER_HEADER_TEXT: {
                    fontFamily: FONT.FAMILY_SECOND,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_LARGE,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                OVERASK_TRADER_BET_OFFER_CONTAINER_BG: COLOR.BRAND.BACKGROUND3,
            },
            [PALETTE_IDS.QUICK_BETSLIP]: {
                QUICK_BETSLIP_PLACE_BET_BUTTON: {
                    PRIMARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontFamily: FONT.FAMILY,
                    },
                },
            },
        },
    };
}
